import React, { ComponentProps } from 'react';
import { useSelector } from 'react-redux';

import HeaderInformer from '@/components/common/header/header-informer/HeaderInformer';
import { errorsSelector } from '@/selectors/error.selectors';

const withError = <T extends React.ElementType>(Component: T) => (props: {
  route?: string;
} & ComponentProps<T>) => {
  const errors = useSelector(errorsSelector);

  return (
    <>
      {(errors || []).length > 0 ? (
        <HeaderInformer
          isError
          text={errors}
          isVisible
        />
      ) : null}

      <Component {...props as React.ComponentProps<T>} />
    </>
  );
};

export default withError;
